import ForumLogoText from '@public/images/ForumLogoText.svg'
import Logo from '@public/images/ForummLogo.svg'
import { Button } from '@components/inputs/Button'
import { Form } from '@components/inputs/Form'
import { TextInput } from '@components/inputs/TextInput'
import { useEffect, useState } from 'react'
import { useAuth } from '@libs/Auth/useAuth'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Box from '@components/base/Box'
import { useTheme } from '@libs/useTheme'

const ForgotPasswordForm = () => {
  const { theme } = useTheme()
  const { sendCode, currentUser } = useAuth()
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  useEffect(() => {
    if (currentUser) router.push('/dashboard')
  }, [currentUser, router])

  return (
    <Box className="flex w-full justify-center h-screen items-center">
      <Box className="flex w-full justify-center items-center max-w-7xl flex-grow overflow-visible">
        <Box className="w-4/5 sm:w-1/2 my-16 relative">
          <Box className="flex flex-col items-center space-y-2">
            <Box
              onClick={() => (window.location.href = 'https://www.forumm.to')}
              className="text-center text-2xl cursor-pointer"
            >
              <div className="flex justify-center items-center mb-12">
                <Logo className="block w-12 mr-2" />
                <ForumLogoText fill={theme.textColour} className="h-6 w-24" />
              </div>
              <p>Forgot your password?</p>
            </Box>
          </Box>

          {sent ? (
            <Box className="mt-8 mb-6 text-center text-sm">
              If an account exists for that email address, we have sent a
              password reset link. Please check your inbox.
            </Box>
          ) : (
            <Form
              onSubmit={async ({ email }) => {
                setLoading(true)
                try {
                  await sendCode(email)
                  setSent(true)
                } catch (error: any) {
                  if (error?.code === 'UserNotFoundException') setSent(true)
                  else return error?.message || 'Unable to send reset link'
                } finally {
                  setLoading(false)
                }
              }}
            >
              <TextInput
                label="Email"
                type="email"
                placeholder="your@mail.com"
                autoComplete="email"
                required
                validations={{
                  minLength: {
                    value: 7,
                    message: 'Email must be at least 7 characters',
                  },
                  maxLength: {
                    value: 70,
                    message: 'Email must be less than 70 characters',
                  },
                }}
              />
              <Button
                buttonType="submit"
                className="my-4 w-full"
                title="Send reset link"
                loading={loading}
              />
            </Form>
          )}

          <Box className="text-sm flex space-x-2 justify-center mb-8 mt-4">
            <span>Remembered your password?</span>
            <Link className="text-link hover:underline" href="/login">
              Log in
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ForgotPasswordForm
